document.addEventListener('DOMContentLoaded', function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var DESKTOP_BREAKPOINT = 980;

  // px/s for each layer type
  var SPEED = {
    left:  50,
    right: 40
  };

  document.querySelectorAll('.local-mv .scroll-track').forEach(function (track) {
    var set = track.querySelector('.scroll-set');
    if (!set) return;

    var layer       = track.closest('.local-mv__layer');
    var isLeft      = layer.classList.contains('local-mv__layer--photos-left');
    var isDesktop   = layer.classList.contains('local-mv__layer--desktop');
    var speed       = isLeft ? SPEED.left : SPEED.right;

    var pos      = 0;
    var lastTime = null;

    function step(timestamp) {
      if (lastTime !== null) {
        var dt      = Math.min(timestamp - lastTime, 100); // cap at 100 ms
        var setSize = isDesktop ? set.offsetHeight : set.offsetWidth;

        if (setSize > 0) {
          pos = (pos + speed * dt / 1000) % setSize;

          if (isDesktop) {
            // left column scrolls up, right column scrolls down
            track.style.transform = isLeft
              ? 'translateY(-' + pos + 'px)'
              : 'translateY(' + (pos - setSize) + 'px)';
          } else {
            // left strip scrolls left, right strip scrolls right
            track.style.transform = isLeft
              ? 'translateX(-' + pos + 'px)'
              : 'translateX(' + (pos - setSize) + 'px)';
          }
        }
      }

      lastTime = timestamp;
      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  });
});
